let video = {
  callVideoNet: {
    //视频拨话

    /***发起视频呼叫，呼叫单个用户，被呼叫用户必须是可视设备，且配置为视频用户。
      发起视频呼叫后，可使用视频组件(OCX控件)在网页(IE11)上使用号码callee作为视频id打开视频。需要注意的是网页上关闭视频不会影响视频通话**/
    url: '/dispatch-web/api/call/makeVideoCall',
    method: 'POST',
    requestParam: {
      token: '',
      caller: '',
      //主叫号码（一般使用坐席号码）
      callee: '',
      //被叫号码
      businessId: '',
      //业务Id，用于业务操作与相关功能的关联
      isRecord: '' //是否录音 预留字段

    },
    responseParam: {
      code: '',
      //返回结果状态码
      message: '',
      systemTime: '',
      //yyyy-MM-dd HH:mm:ss
      data: ''
    }
  },
  // 获取设备列表 queryfacilitylist, 通过改接口可以知晓记录仪状态
  getFacilityListNet: {
    url: '/scooper-video/data/facility/queryFacilityList',
    method: 'POST',
    paramOnUrl: ['token'],
    requestParam: {
      token: '',
      parentId: '' //219

    },
    responseParam: {
      code: '',
      //返回结果状态码
      message: '',
      systemTime: '',
      //yyyy-MM-dd HH:mm:ss
      data: {
        total: 100,
        //总记录数
        list: [{
          devId: '',
          //设备id
          id: '',
          //数据id
          ipcType: '',
          //设备类型
          isActive: '',
          //是否激活
          name: '',
          //设备名称
          parentId: '',
          //父节点id
          orgCode: '',
          //组织机构编码
          parental: '',
          //是否有子节点 0-没有(设备)，1-有(目录节点)
          sort: '',
          //排序号
          status: '' //设备状态 2:空闲/离线  1：在线

        }]
      }
    }
  },
  videoStatusMQNet: function (accId) {
    //视频通话状态通知
    return {
      /**
       * 用于视频通话时判断是否视频通话建立or结束的通知，如视频呼叫某号码，该号码摘机建立视频通话后操作员收到cfgType=decoder_info通知，则第三方在收到通知时根据实际需求判断是否需要打开通话视频。
        （同理，视频加入会议，视频呼入调度与坐席通话也根据该通知判断视频打开/结束）
       */
      topic: `/${accId}/dispatch-web/notify/call/video`,
      responseParam: {
        id: 0,
        //数据id
        type: 'video',
        //消息类别
        source: 'dispatch-web',
        //消息来源
        data: {
          //通知的具体消息
          cfgType: '',
          //视频通话状态  decoder_info：视频通话建立 stop_decoder:视频通话结束
          tel: '',
          //通知号码
          accId: '',
          //消息接收的账号id
          account: '' //消息接收的账号名

        }
      }
    };
  },
  getNodesVideoNet: {
    //加载视频树节点数据(树型结构)

    /***
     * 树图层级加载树节点数据接口，查询返回的设备数据根据权限配置的数据节点过滤后获得
     * *
     * */
    url: '/scooper-video/data/video/load/getNodes',
    method: 'POST',
    requestParam: {
      token: '',
      parentId: '' //父节点节点id，关联父节点的nodeId 默认0，加载一级节点（控制中心）

    },
    responseParam: {
      code: '',
      //返回结果状态码
      message: '',
      systemTime: '',
      //yyyy-MM-dd HH:mm:ss
      data: [{
        id: '',
        //	Int	T	数据序号，没有节点意义
        nodeId: '',
        //	Int	T	节点Id,用于上下级查询
        devId: '',
        //	String	T	视频设备编号，可用于视频打开等操作
        dev_short_num: '',
        //	String	F	视频设备短号，可用于视频打开等操作
        name: '',
        //	String	T	设备名称
        parental: '',
        //	Int	T	是否有子节点 0-没有(设备)，1-有(目录节点)
        parentid: '',
        //	Int	T	父节点id，关联父节点的nodeId
        port: '',
        //	String	F	端口
        sort: '',
        //	Int	F	排序号（暂时不支持）
        status: '',
        //	String	F	在/离线状态parental=0（设备）这个属性有值，标识设备的在离线
        province: '',
        //	String	F	省
        city: '',
        //	String	F	市
        district: '',
        //	String	F	区县
        ipaddress: '',
        //	String	F	IP地址
        latitude: '',
        //	String	F	纬度
        longitude: '' //	String	F	经度

      }]
    }
  }
};
export default video;